var path = 'device/device-card.tpl.html';
var html = "\n<div flex layout=\"column\" style=\"margin-top: -10px;\">\n    <div style=\"text-transform: uppercase; padding-bottom: 5px;\">{{vm.item.type}}</div>\n    <div class=\"tb-card-description\">{{vm.item.additionalInfo.description}}</div>\n    <div style=\"padding-top: 5px;\" class=\"tb-small\" ng-show=\"vm.isAssignedToCustomer()\">{{'device.assignedToCustomer' | translate}} '{{vm.item.assignedCustomer.title}}'</div>\n    <div style=\"padding-top: 5px;\" class=\"tb-small\" ng-show=\"vm.isPublic()\">{{'device.public' | translate}}</div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/device/device-card.tpl.html
// module id = 1449
// module chunks = 1